export default __webpack_public_path__ + "static/media/saung_pananjung.809138c6.png";